import { Modal, Text } from '@viapeople/components'
import type { DependentComponent } from '../helpers/conditionalHelpers'

interface DeleteComponentDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	componentLabel: string
	dependentComponents: DependentComponent[]
}

export function DeleteComponentDialog({
	isOpen,
	onClose,
	onConfirm,
	componentLabel,
	dependentComponents,
}: DeleteComponentDialogProps) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title='Delete Component'
			buttons={[
				{ children: 'Cancel', onClick: onClose, variant: 'secondary' },
				{ children: 'Delete', onClick: onConfirm, variant: 'destructive' },
			]}>
			<div className='space-y-4'>
				<Text variant='small'>
					Deleting &ldquo;{componentLabel}&rdquo; will affect conditional visibility rules on the following components:
				</Text>
				<ul className='space-y-1 list-disc list-inside'>
					{dependentComponents.map((dep) => (
						<li key={dep.id}>
							<Text variant='small'>{dep.label}</Text>
						</li>
					))}
				</ul>
				<Text variant='small'>The conditions referencing this component will be automatically removed.</Text>
			</div>
		</Modal>
	)
}
